import React from 'react';

import Overlay from 'ol/Overlay';
import { useSelector } from 'react-redux';

import { hasObjectKeys } from 'utils/main';

const tooltipStyle = {
  background: 'rgba(0, 0, 0, 0.8)',
  color: '#fff',
  padding: '5px 10px',
  borderRadius: '4px',
  fontSize: '12px',
  whiteSpace: 'nowrap',
  pointerEvents: 'none',
};

const TransmissionTowers = () => {
  const map = useSelector(state => state.map);
  const tooltipRef = React.useRef(null);
  const overlayRef = React.useRef(null);

  React.useEffect(() => {
    if (!hasObjectKeys(map) || !tooltipRef.current) return;

    const overlay = new Overlay({
      id: 'transmissionTowerTooltip',
      element: tooltipRef.current,
      offset: [0, -12],
      positioning: 'bottom-center',
    });
    overlayRef.current = overlay;
    map.addOverlay(overlay);

    const handlePointerMove = event => {
      let hit = false;
      map.forEachFeatureAtPixel(event.pixel, feature => {
        if (feature.getProperties().detail === 'transmissionTower') {
          const name = feature.getProperties().name;
          tooltipRef.current.innerHTML = name;
          overlay.setPosition(event.coordinate);
          hit = true;
        }
      });
      if (!hit) {
        overlay.setPosition(undefined);
      }
      map.getTargetElement().style.cursor = hit ? 'pointer' : '';
    };

    map.on('pointermove', handlePointerMove);

    return () => {
      map.un('pointermove', handlePointerMove);
      map.removeOverlay(overlay);
    };
  }, [map]);

  return <div ref={tooltipRef} style={tooltipStyle} />;
};

export default React.memo(TransmissionTowers);
